<script setup lang="ts">
import { PhHouse as House } from "@phosphor-icons/vue";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
</script>

<template>
  <button class="icon-button home-button" type="button" aria-label="返回首页" title="返回首页" @click="store.go('home')">
    <House :size="22" weight="fill" />
  </button>
</template>
